// extracted by mini-css-extract-plugin
export default {"PageNavItemEndpointBadge":"PageNavItemEndpointBadgeThaLyYpVXh2Q"};